import React from 'react'
import { connect } from 'react-redux'

import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import Gearbox from './Gearbox'
import ReactivationForm from './ReactivationForm'
import HomeSideNav from './HomeSideNav'
import AdminContactCards from '../../profile/components/AdminContactCards'

import '../style/home.scss'
const Home = ({ user, accountStatusCode, reactivationFormState, serverProperties, trainingUrl }) =>
  <div className='home'>

    {accountStatusCode === 0 && // Inactive (this should only happen with VIP linked accounts that are already in this status)
      ((user.entities.some(ent => ent.name === 'LenderAdminUser') || user.entities.some(ent => ent.name === 'ServicerAdminUser')) && user.affiliations.some(aff => aff.name === 'LENDER' || aff.name === 'SERVICER') ?
        <ReactivationForm user={user} submitState={reactivationFormState} /> :
        <LgyAlertDialog type='warning' heading='Account Inactive'>
          Your account was inactivated. Please <LgyLink to='/lgyhub/help/ticket'>contact the helpdesk</LgyLink> for more information.
      </LgyAlertDialog>)}

    {accountStatusCode === 1 && // Active (and the most common result)
      <div className='usa-grid'>
        <div className='usa-width-one-fourth'>
          <HomeSideNav currentUser={user} serverProperties={serverProperties} trainingUrl={trainingUrl} />
        </div>
        <div className='usa-width-three-fourths'>
          <Gearbox currentUser={user} />
        </div>
      </div>
    }
    {
      accountStatusCode === 2 && // Terminated
      ((user.isAffiliate && user.affiliations && user.affiliations.some(aff => aff.name === 'LENDER' || aff.name === 'SERVICER') ?
        <ReactivationForm user={user} submitState={reactivationFormState} /> :
        <LgyAlertDialog type='warning' heading='Account Inactive'>
          Your account has been temporarily terminated. Please <LgyLink to='/lgyhub/help/ticket'>contact the helpdesk</LgyLink> for more information.
        </LgyAlertDialog>))
    }

    {
      accountStatusCode === 3 && // Batch Inactive
      ((user.isAffiliate && user.affiliations && user.affiliations.some(aff => (aff.name === 'LENDER' || aff.name === 'SERVICER') && aff.name !== 'SAR') ?
        <ReactivationForm user={user} submitState={reactivationFormState} /> : // lender/servicers that are not admins
        <LgyAlertDialog type='warning' heading='Account Inactive'>
          Your account was deactivated due to inactivity. Please <LgyLink to='/lgyhub/help/ticket'>contact the helpdesk</LgyLink> for more information.
        </LgyAlertDialog>))
    }

    {
      accountStatusCode === 4 && // Registration Inactivation (Note: Statuses 4, 5, and 6 should only be for lender/servicer accounts)      
      ((user.entities.some(ent => ent.name === 'LenderAdminUser') || user.entities.some(ent => ent.name === 'ServicerAdminUser')) && user.affiliations.some(aff => aff.name === 'LENDER' || aff.name === 'SERVICER') ?
        <ReactivationForm user={user} submitState={reactivationFormState} /> :
        <LgyAlertDialog type='info' heading='Thank You'>
          You have successfully registered, however your account must be validated prior to accessing the full site.
        {user.entities.some(ent => ent.name === 'LenderAdminUser') || user.entities.some(ent => ent.name === 'ServicerAdminUser') ?
            <span> Please <LgyLink to='/lgyhub/help/ticket'>contact the helpdesk</LgyLink> for more information.</span> :
            ' Your registration or reactivation was successful and is pending approval from your company\'s administrator (admin). You will receive an e-mail when your account has been activated.  Please contact your company admin for more information.'}
          <AdminContactCards affiliate={user.affiliations.find(el => el.name === 'LENDER' || el.name === 'SERVICER')} />
        </LgyAlertDialog>)

    }

    {
      accountStatusCode === 5 && // Admin Inactive/Removed
      ((user.isAffiliate && user.affiliations && user.affiliations.some(aff => (aff.name === 'LENDER' || aff.name === 'SERVICER') && aff.name !== 'SAR') ?
        <ReactivationForm user={user} submitState={reactivationFormState} /> :
        <LgyAlertDialog type='warning' heading='Account Inactive'>
          Your account was inactivated. Please <LgyLink to='/lgyhub/help/ticket'>contact the helpdesk</LgyLink> for more information.
        </LgyAlertDialog>))
    }

    {
      accountStatusCode === 6 && // Pending Reactivation
      ((user.entities.some(ent => ent.name === 'LenderAdminUser') || user.entities.some(ent => ent.name === 'ServicerAdminUser')) && user.affiliations.some(aff => aff.name === 'LENDER' || aff.name === 'SERVICER') ?
        <ReactivationForm user={user} submitState={reactivationFormState} /> :
        <LgyAlertDialog type='info' heading='Thank You'>
          Your registration or reactivation was successful and is pending approval from your company's administrator (admin). You will receive an e-mail when your account has been activated.  Please contact your company admin for more information.
          <AdminContactCards affiliate={user.affiliations.find(el => el.name === 'LENDER' || el.name === 'SERVICER')}/>
        </LgyAlertDialog>)
    }

    {(accountStatusCode === null || !(accountStatusCode <= 6 && accountStatusCode >= 0)) && // Default
      <LgyAlertDialog type='error' heading='Error'>
        Unable to determine user status. Please <LgyLink to='/lgyhub/help/ticket'>submit a ticket</LgyLink> to our helpdesk.
      </LgyAlertDialog>
    }
  </div>

const mapStateToProps = (state) => ({
  user: state.currentUser,
  accountStatusCode: state.currentUser.accountStatusCode,
  reactivationFormState: state.reactivationForm,
  serverProperties: state.serverProperties,
  trainingUrl : state.trainingUrl
})

export default connect(mapStateToProps)(Home)
